/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Marker_Import_Source_Preview_AriaInputs */

const en_marker_import_source_preview_aria = /** @type {(inputs: Marker_Import_Source_Preview_AriaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Source file preview`)
};

const fr_marker_import_source_preview_aria = /** @type {(inputs: Marker_Import_Source_Preview_AriaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Apercu du fichier source`)
};

const de_marker_import_source_preview_aria = /** @type {(inputs: Marker_Import_Source_Preview_AriaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vorschau der Quelldatei`)
};

const it_marker_import_source_preview_aria = /** @type {(inputs: Marker_Import_Source_Preview_AriaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Anteprima del file sorgente`)
};

const ru_marker_import_source_preview_aria = /** @type {(inputs: Marker_Import_Source_Preview_AriaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Предварительный просмотр исходного файла`)
};

const es_marker_import_source_preview_aria = /** @type {(inputs: Marker_Import_Source_Preview_AriaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vista previa del archivo fuente`)
};

const zh_cn2_marker_import_source_preview_aria = /** @type {(inputs: Marker_Import_Source_Preview_AriaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`源文件预览`)
};

const ja_marker_import_source_preview_aria = /** @type {(inputs: Marker_Import_Source_Preview_AriaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ソースファイルのプレビュー`)
};

const hi_marker_import_source_preview_aria = /** @type {(inputs: Marker_Import_Source_Preview_AriaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`स्रोत फ़ाइल पूर्वावलोकन`)
};

const pt_pt2_marker_import_source_preview_aria = /** @type {(inputs: Marker_Import_Source_Preview_AriaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pré-visualização do arquivo de origem`)
};

/**
* | output |
* | --- |
* | "Source file preview" |
*
* @param {Marker_Import_Source_Preview_AriaInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const marker_import_source_preview_aria = /** @type {((inputs?: Marker_Import_Source_Preview_AriaInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Marker_Import_Source_Preview_AriaInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_marker_import_source_preview_aria(inputs)
	if (locale === "de") return de_marker_import_source_preview_aria(inputs)
	if (locale === "it") return it_marker_import_source_preview_aria(inputs)
	if (locale === "ru") return ru_marker_import_source_preview_aria(inputs)
	if (locale === "es") return es_marker_import_source_preview_aria(inputs)
	if (locale === "zh-CN") return zh_cn2_marker_import_source_preview_aria(inputs)
	if (locale === "ja") return ja_marker_import_source_preview_aria(inputs)
	if (locale === "hi") return hi_marker_import_source_preview_aria(inputs)
	if (locale === "pt-PT") return pt_pt2_marker_import_source_preview_aria(inputs)
	return en_marker_import_source_preview_aria(inputs)
});